import { render, staticRenderFns } from "./startDescript.vue?vue&type=template&id=7a17773e&scoped=true"
import script from "./startDescript.vue?vue&type=script&lang=js"
export * from "./startDescript.vue?vue&type=script&lang=js"
import style0 from "./startDescript.vue?vue&type=style&index=0&id=7a17773e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a17773e",
  null
  
)

export default component.exports